<template>
  <div class="agent-wrap">
    <div class="agent-hdr">
      <div class="agent-hdr-avatar"><i class="ti ti-settings-ai" aria-hidden="true" style="font-size:20px"></i></div>
      <div>
        <div class="agent-hdr-title">AI 어시스턴트</div>
        <div class="agent-hdr-sub"><span class="agent-dot"></span>온라인</div>
      </div>
      
      <button style="margin-left: auto; align-self: flex-start;" @click="hideSidebar">
        <i class="ti ti-layout-sidebar-right-collapse-filled" style="font-size:15px" aria-hidden="true"></i>
      </button>

    </div>
    <div class="msgs" ref="msgEl">
      <div v-for="msg in this.messages" :key="msg.id" class="msgs-row" :class="msg.role">
        <div class="msgs-av" :class="msg.role">
          <i v-if="msg.role==='bot'" class="ti ti-settings-ai" aria-hidden="true" style="font-size:16px"></i>
          <i v-else class="ti ti-user-square-rounded" style="font-size:15px"></i>
        </div>
        <div>
          <div class="msgs-bub" :class="msg.role">
            <div 
              class="copy-container" 
              @mouseenter="hoveredId = msg.id" 
              @mouseleave="hoveredId = null" >
              <transition name="fade">
                <button
                  v-show="hoveredId===msg.id && msg.role==='bot' && msg.type==='answer'"
                  class="copy-btn"
                  @click="copyToClipboard(msg.id, msg.text)"
                >
                  <i v-if="copiedId===null" class="ti ti-copy" />
                  <i v-else class="ti ti-check"/>
                </button>
              </transition>
              <div class="msgs-bub-line" v-for="(line, index) in parseLines(msg.text)" :key="index">
                <div v-html="convertedHTML(line)" />
              </div>
            </div>
          </div>
          <div class="msgs-bub-time">{{ msg.time }}</div>
        </div>
      </div>
      <div v-if="isTyping" class="msgs-row bot">
        <div class="msgs-av bot"><i class="ti ti-settings-ai" aria-hidden="true" style="font-size:15px"></i></div>
        <div class="msgs-typing-wrap">
          <div class="msgs-bub bot">
            <span class="msgs-tdot"></span><span class="msgs-tdot"></span><span class="msgs-tdot"></span>
          </div>
          <div class="msgs-typing-text">{{ typingText }}</div>
        </div>
      </div>
    </div>

    <!-- 질문 선택 패널 -->
    <div class="q-panel">
      <!-- 초기 질문 세트 -->
      <div v-if="!isAnswered">
        <div class="d-flex">
          <div class="q-label">✨ 추천 질문 목록</div>
          <button v-b-toggle.q-collapse class="ml-1 toggle-btn text-center">
            <span class="when-open" style="color: var(--color-text-tertiary);">▲</span>
            <span class="when-closed" style="color: var(--color-text-tertiary);">▼</span>
          </button>
          <button class="reset-btn" style="margin-left: auto;" @click="this.reset">
            <i class="ti ti-refresh" style="font-size:13px" aria-hidden="true"></i>
            초기화
          </button>
        </div>
        <div>
        <b-collapse id="q-collapse" visible>
          <div class="q-list">
            <button
              v-for="q in questions"
              :key="q.id"
              class="q-btn"
              :disabled="isTyping"
              @click="selectQuestion(q)"
            >
              <i class="ti ti-message-question" style="font-size:15px" aria-hidden="true"></i>
              {{ q.label }}
            </button>
          </div>
        </b-collapse>
        </div>
      </div>

      <!-- 추가 질문 세트 -->
      <div v-else>
        <div class="d-flex">
          <div class="q-label">데이터셋 기간 설정</div>
          <button class="reset-btn" style="margin-left: auto;" @click="this.reset">
            <i class="ti ti-refresh" style="font-size:13px" aria-hidden="true"></i>
            초기화
          </button>
        </div>
        <div class="q-list">
          <button
              v-for="q in followUps"
              :key="q.id"
              class="q-btn"
              :disabled="isTyping"
              @click="selectFollowUp(q)"
          >
              <i class="ti ti-calendar-week" style="font-size:15px" aria-hidden="true"></i>
              {{ q.label }}
          </button>
        </div>
      </div>
    </div>
    <div class="user-q-panel">
      <b-input-group>
        <b-form-input
          class="user-q-input"
          v-model="user_question"
          placeholder="질문을 입력하세요..."
          type="text"
          autocomplete="off"
          :disabled="isAnswered || isTyping"
        />
        <b-input-group-append v-if="user_question">
          <button class="ml-1 q-btn" @click="sendUserQuestion">
            <i class="ti ti-send" style="font-size:15px" aria-hidden="true"></i>
          </button>
        </b-input-group-append>
      </b-input-group>
    </div>
  </div>
</template>

<script>
import { ref, nextTick } from '@vue/composition-api'

import {
  BFormInput,
  BCollapse,
  BButton,
  VBToggle,
  BInputGroupAppend,
  BInputGroup
} from "bootstrap-vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent";

import AiAgentService from "@/services/cis-aiagent.service";

import axios from "axios"
import moment from "moment";

import useJwt from "@/auth/jwt/useJwt";

import jwtDefaultConfig from "@core/auth/jwt/jwtDefaultConfig"

import ExpXlMarketOverview from './library/ExportXlMarketOverview';
import ExpXlShareofSearch from './library/ExportXlShareofSearch';
import ExpXlSearchTag from './library/ExportXlSearchTag';
import ExpXlInsight from './library/ExportXlInsight';

import makeDtSetMarketOverview from './library/MakeDataSetMarketOverview';
import makeDtSetShareofSearch from './library/MakeDataSetShareofSearch';
import makeDtSetSearchTag from './library/MakeDataSetSearchTag';
import makeDtSetInsight from './library/MakeDataSetInsight';

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

export default {
    name: "AiAgentSidebar",
    components: {
      BFormInput,
      BInputGroup,
      BInputGroupAppend,
      BCollapse,
      BButton,
      VBToggle
    },
    directives: {
      "b-toggle": VBToggle,
    },
    data() {
        return {
          user_id : "",
          sess_id : "",

          serv_nm : "",
          sel_question : "",
          sel_category : "",
          typingText : "",

          messages : [],
          questions : [],
          followUps : [],
          user_question: "",

          isActive : false,
          isAnswered : false,
          isTyping : false,

          msgEl : null,
          cnt : 0,

          // for clipboard
          copiedId: null,
          hoveredId: null
        };
    },
    computed: {
      check_AiAgent_Visibility() {
        return this.$store.getters.getAiAgentVisibility
      },

      check_Selected_Menu() {
        return this.$store.getters.getSelectedCISMenu
      },

      check_Selected_Category() {
        return this.$store.getters.getSelectedCategory
      }
    },
    watch: {
      async check_Selected_Menu(menu) {
        switch(menu) {
          case 'trendkeyword':
          case 'tracking':
            await this.hideSidebar()
            break
          case 'competition':
            this.serv_nm = 'shareofsearch'
            break
          default:
            this.serv_nm = menu
            break
        }

        if (this.isActive)
          await this.updateQuestions()
      },

      async check_Selected_Category(category) {
        this.sel_category = category

        console.log('----- category -----')
        console.log(this.sel_category)
      },

      async check_AiAgent_Visibility(visibility) {
        this.isActive = visibility

        if (this.isActive)
          await this.updateQuestions()
      },

      messages(newMessage) {
        if(newMessage) {
          sessionStorage.removeItem(jwtDefaultConfig.agentMessageKey)

          sessionStorage.setItem(jwtDefaultConfig.agentMessageKey, JSON.stringify(newMessage))
          sessionStorage.setItem(jwtDefaultConfig.agentStatusKey, JSON.stringify({'answered' : this.isAnswered, 'typing': this.isTyping}))
        }
      } 
    },
    methods: {
      async sendUserQuestion(event){
        if (event.isComposing)
          return

        await this.selectQuestion({'id': this.questions.length + 1, 'label': this.user_question, 'question': this.user_question, 'serv_nm': this.serv_nm})

        this.user_question = ""
      },

      async pushMessage(role, type, text) {
        this.messages.push({ id: ++this.cnt, role: role, type: type, text: text, time: this.getCurrTime() });
        await this.scrollSync();
      },

      async typeWrite(text) {
        this.messages[this.cnt].text = ""

        if (text == null || text.length == 0) 
          return

        let i = 0;

        const timer = setInterval(() => {
          this.messages[this.cnt].text += text[i++]
          this.scrollSync();

          if (i >= text.length) {
            this.messages[this.cnt].text = text

            clearInterval(timer)

            this.pushMessage('bot', 'request', '질문을 입력하거나 추천 질문 중 하나를 선택해 주세요.')
          }
        }, 20)
      },

      parseLines(text) {
        if (!text) return [];

        const res = text
          .split(/(?=(?<![a-zA-Z가-힣\d])-(?![a-zA-Z가-힣\d])|(?=###))/)
          .map(s => s.trim())
          .filter(s => s);

        return res
      },

      convertedHTML(text) {
        return text
          .replace(/###\s*(.+)/g, '<h6 style="color: #222;"><b>$1</b></h6>')
          .replace(/\*\*(.*?)\*\*/g, '<strong><u>$1</u></strong>')                                            // **bold**
          .replace(/\*(.*?)\*/g, '<em>$1</em>')                                                               // *italic*
          .replace(/`(.*?)`/g, '<code>$1</code>')                                                             // `code`
          .replace(/\[\[?(.*?)\]?\]/g, '$1')                                                                  // [[텍스트]] → 텍스트
          .replace(/\-\s(.+)/gm, '<span style="display:inline-block; margin-left:8px;">- $1</span>')          // * 항목 들여쓰기
          .replace(/\*\s(.+)/gm, '<br/><span style="display:inline-block; margin-left:12px;">• $1</span>');   // * 항목 들여쓰기
      },

      getCurrTime() {
        return new Date().toLocaleTimeString('ko-KR', { hour:'2-digit', minute:'2-digit' });
      },

      reset() {
        this.messages = [{ id:0, role:'bot', type: 'request', text:'질문을 입력하거나 추천 질문 중 하나를 선택해 주세요.', time: this.getCurrTime() }];
        this.isAnswered = false;
        this.cnt = 0;


      },

      async scrollSync() {
        await nextTick(); 
        
        if(this.$refs.msgEl) 
          this.$refs.msgEl.scrollTop = this.$refs.msgEl.scrollHeight;
      },

      async hideSidebar() {
        this.$store.dispatch('callAiAgentVisibility', { visibility : false })
      },

      calcSelectPeriod(periodType) {
        var en_dt = moment().add(-2, 'days').toDate(); // 데이터 업데이트 시점을 고려
        var st_dt = moment(en_dt).add(-(Number(periodType) * 12 - 1) , 'month').toDate();

        return { 'st_dt': moment(st_dt).format("YYYY-MM"), 'en_dt': moment(en_dt).format("YYYY-MM") }
      },

      async selectFollowUp(q) 
      {
        if(this.isTyping) 
          return;

        if(q.label == '👈 다시 질문 선택하기') {
          this.isTyping = false;
          this.isAnswered = false; 
          
          this.pushMessage('user', 'status', q.label)
        
          this.sel_question = ""

          this.pushMessage('bot', 'request', '질문을 입력하거나 추천 질문 중 하나를 선택해 주세요.')

          return;
        }

        try {
          this.pushMessage('user', 'question', q.label)

          this.isTyping = true;

          var dt_path = ""
          var period = q.label.replace("최근", "").replace("년", "").trim()

          // 1) 기본 요청에 대한 질문(기간 정보)을 전달한다.
          const { st_dt, en_dt } = this.calcSelectPeriod(period)

          this.typingText = '데이터 셋 검토 중...'

          // 2) 해당 요청 사항과 일치하는 데이터 셋 존재 여부를 확인한다.
          const hasDtSet =  await AiAgentService.hasDataset({
            "serv_nm": this.serv_nm,
            "cat_id": this.sel_category,
            "st_dt": st_dt,
            "en_dt": en_dt
          }, source)

          console.log('----- AI Agent | Check Dataset -----')
          console.log(hasDtSet)

          if (hasDtSet && hasDtSet.status == 200) {
            if (hasDtSet.data.data && hasDtSet.data.data.length > 0)
              dt_path = hasDtSet.data.data[0]
          }
          else
            throw new Error("데이터셋 존재 유무 확인 실패!!")

          // 3) 데이터셋이 존재하지 않을 경우 생성한다.
          if (dt_path.length == 0) {
            this.typingText = '데이터 셋 생성 중...'
            
            const dataset = await this.getDataset(this.serv_nm, st_dt, en_dt)

            dt_path = await this.saveToExcel(this.sel_category, this.serv_nm, st_dt, en_dt, dataset)

            if (dt_path.length == 0)
              throw new Error("데이터 셋 생성 실패!!")
          }

          const majorList = await this.getMajorList(this.serv_nm, st_dt, en_dt)

          this.typingText = '데이터 셋 분석 및 결과 정리 중...'

          switch(this.serv_nm) {
            case 'marketoverview':
              try {
                // 4) 데이터셋과 질문 내용을 AI Agent에 전달한다.
                const response = await AiAgentService.callAiAgent_MarketOverview(
                  {
                    "session_id" : this.sess_id,
                    "user_id": this.user_id, 
                    "parts": [
                      { "type": "text", "text": this.sel_question }
                    ],
                    "dataset": {
                      "path": dt_path,
                      "cat_id": this.sel_category,
                      "serv_nm": this.serv_nm,
                      "col_st_dt": st_dt,
                      "col_en_dt": en_dt,
                      "major_list": majorList
                    }
                  }, source)

                // 5) 응답 결과를 출력한다.  
                console.log('----- AI Agent | Market Overview -----')
                console.log(response)

                if(response && response.status == 200 && response.data != null) {
                  if (!response.data.data || !response.data.data.response_text)
                  // if (!response.data || !response.data.response_text) // for local test
                    throw new Error("응답 데이터 형식이 올바르지 않습니다.")

                  setTimeout(async () => {
                    this.isTyping = false;
                    this.isAnswered = false;
                    this.pushMessage('bot', 'answer', response.data.data.response_text)
                    // this.pushMessage('bot', 'answer', response.data.response_text) // for local test

                    await this.$nextTick();
                    await this.typeWrite(response.data.data.response_text)
                    // await this.typeWrite(response.data.response_text) // for local test
                  }, 500);
                }
                else
                  throw new Error("데이터 셋 분석 또는 결과 정리 실패!!")
              }
              catch (err) {
                throw err
              }

              break
            case 'shareofsearch':
              try {
                // 4) 데이터셋과 질문 내용을 AI Agent에 전달한다.
                const response = await AiAgentService.callAiAgent_ShareofSearch(
                  {
                    "session_id" : this.sess_id,
                    "user_id": this.user_id, 
                    "parts": [
                      { "type": "text", "text": this.sel_question }
                    ],
                    "dataset": {
                      "path": dt_path,
                      "cat_id": this.sel_category,
                      "serv_nm": this.serv_nm,
                      "col_st_dt": st_dt,
                      "col_en_dt": en_dt,
                      "major_list": majorList
                    }
                  }, source)

                // 5) 응답 결과를 출력한다.  
                console.log('----- AI Agent | Share of Search -----')
                console.log(response)

                if(response && response.status == 200 && response.data != null) {
                  if (!response.data.data || !response.data.data.response_text)
                  // if (!response.data || !response.data.response_text) // for local test
                    throw new Error("응답 데이터 형식이 올바르지 않습니다.")

                  setTimeout(async () => {
                    this.isTyping = false;
                    this.isAnswered = false;
                    this.pushMessage('bot', 'answer', response.data.data.response_text)
                    // this.pushMessage('bot', 'answer', response.data.response_text) // for local test

                    await this.$nextTick();
                    await this.typeWrite(response.data.data.response_text)
                    // await this.typeWrite(response.data.response_text) // for local test
                  }, 500);
                }
                else
                  throw new Error("데이터 셋 분석 또는 결과 정리 실패!!")
              }
              catch (err) {
                throw err
              }

              break
            case 'searchtag':
              try {
                // 4) 데이터셋과 질문 내용을 AI Agent에 전달한다.
                const response = await AiAgentService.callAiAgent_SearchTag(
                  {
                    "session_id" : this.sess_id,
                    "user_id": this.user_id, 
                    "parts": [
                      { "type": "text", "text": this.sel_question }
                    ],
                    "dataset": {
                      "path": dt_path,
                      "cat_id": this.sel_category,
                      "serv_nm": this.serv_nm,
                      "col_st_dt": st_dt,
                      "col_en_dt": en_dt,
                      "major_list": majorList
                    }
                  }, source)

                // 5) 응답 결과를 출력한다.  
                console.log('----- AI Agent | Search Tag -----')
                console.log(response)

                if(response && response.status == 200 && response.data != null) {
                  if (!response.data.data || !response.data.data.response_text)
                  // if (!response.data || !response.data.response_text) // for local test
                    throw new Error("응답 데이터 형식이 올바르지 않습니다.")

                  setTimeout(async () => {
                    this.isTyping = false;
                    this.isAnswered = false;
                    this.pushMessage('bot', 'answer', response.data.data.response_text)
                    // this.pushMessage('bot', 'answer', response.data.response_text) // for local test

                    await this.$nextTick();
                    await this.typeWrite(response.data.data.response_text)
                    // await this.typeWrite(response.data.response_text) // for local test
                  }, 500);
                }
                else
                  throw new Error("데이터 셋 분석 또는 결과 정리 실패!!")
              }
              catch (err) {
                throw err
              }

              break
            case 'insight':
              try {
                // 4) 데이터셋과 질문 내용을 AI Agent에 전달한다.
                const response = await AiAgentService.callAiAgent_Insight(
                  {
                    "session_id" : this.sess_id,
                    "user_id": this.user_id, 
                    "parts": [
                      { "type": "text", "text": this.sel_question }
                    ],
                    "dataset": {
                      "path": dt_path,
                      "cat_id": this.sel_category,
                      "serv_nm": this.serv_nm,
                      "col_st_dt": st_dt,
                      "col_en_dt": en_dt,
                      "major_list": majorList
                    }
                  }, source)

                // 5) 응답 결과를 출력한다.  
                console.log('----- AI Agent | Insight -----')
                console.log(response)

                if(response && response.status == 200 && response.data != null) {
                  if (!response.data.data || !response.data.data.response_text)
                  // if (!response.data || !response.data.response_text) // for local test
                    throw new Error("응답 데이터 형식이 올바르지 않습니다.")

                  setTimeout(async () => {
                    this.isTyping = false;
                    this.isAnswered = false;
                    this.pushMessage('bot', 'answer', response.data.data.response_text)
                    // this.pushMessage('bot', 'answer', response.data.response_text) // for local test

                    await this.$nextTick();
                    await this.typeWrite(response.data.data.response_text)
                    // await this.typeWrite(response.data.response_text) // for local test
                  }, 500);
                }
                else
                  throw new Error("데이터 셋 분석 또는 결과 정리 실패!!")
              }
              catch (err) {
                throw err
              }

              break
          }
        }
        catch (err) {
          console.log(err)

          setTimeout(async () => {
            this.isTyping = false;
            this.isAnswered = false;
            this.pushMessage('bot', 'request', '잠시 후 다시 시도해 주세요.')
          }, 500);
        }
      },

      async selectQuestion(q) {
        if(this.isTyping) 
          return;
        
        this.pushMessage('user', 'question', q.label)

        this.isTyping = true;
        this.sel_question = q.question;

        await this.scrollSync();

        setTimeout(async () => {
          this.isTyping = false;
          this.isAnswered = true;
          this.pushMessage('bot', 'request', '데이터 셋의 기간을 선택해 주세요.')
        }, 100);
      },

      async updateQuestions() {
        this.questions = []

        if (this.serv_nm.length == 0)
        {
          this.serv_nm = this.$store.getters.getSelectedCISMenu

          if (this.serv_nm == 'competition')
            this.serv_nm = 'shareofsearch'
        }
         
        const response = await AiAgentService.getServiceQuestion({'serv_nm' : this.serv_nm}, source)

        if(response && response.status == 200) {
          var id = 1

          for (const q of response.data.data) {
            this.questions.push({'id': id++, 'label': q.qrepStr, 'question': q.qstr, 'serv_nm': this.serv_nm})
          }
        }

        await this.scrollSync();

        this.updateFollowUps();
      },

      updateFollowUps() {
        this.followUps = []

        switch(this.serv_nm) {
          case 'marketoverview':
            this.followUps.push(
              {'id': 0, 'label': '최근 3년'},
              {'id': 1, 'label': '최근 5년'},
              {'id': 2, 'label': '최근 7년'},
              {'id': 3, 'label': '👈 다시 질문 선택하기'},
            )

            break
          case 'shareofsearch':
          case 'searchtag':
          case 'insight':
            this.followUps.push(
              {'id': 0, 'label': '최근 1년'},
              {'id': 1, 'label': '최근 2년'},
              {'id': 2, 'label': '최근 3년'},
              {'id': 3, 'label': '👈 다시 질문 선택하기'},
            )
            
            break
        }
      },

      async getDataset(serv_nm, st_dt, en_dt) {
        switch(serv_nm) {
          case 'marketoverview':
            const useMakeDtsetMarketOverview = new makeDtSetMarketOverview(this.sel_category, st_dt, en_dt)

            await useMakeDtsetMarketOverview.initialize()

            return await useMakeDtsetMarketOverview.run()

          case 'shareofsearch':
            const useMakeDtShareofSearch = new makeDtSetShareofSearch(this.sel_category, st_dt, en_dt)

            await useMakeDtShareofSearch.initialize()

            return await useMakeDtShareofSearch.run()

          case 'searchtag':
            const useMakeDtSearchTag = new makeDtSetSearchTag(this.sel_category, st_dt, en_dt)

            await useMakeDtSearchTag.initialize()

            return await useMakeDtSearchTag.run()
            
          case 'insight':
            const useMakeDtInsight = new makeDtSetInsight(this.sel_category, st_dt, en_dt)

            await useMakeDtInsight.initialize()

            return await useMakeDtInsight.run()
        }
      },

      async getMajorList(serv_nm, st_dt, en_dt) {
        switch(serv_nm) {
          case 'marketoverview':
            const useMakeDtsetMarketOverview = new makeDtSetMarketOverview(this.sel_category, st_dt, en_dt)

            await useMakeDtsetMarketOverview.initialize()

            return useMakeDtsetMarketOverview.majorClsList

          case 'shareofsearch':
            const useMakeDtShareofSearch = new makeDtSetShareofSearch(this.sel_category, st_dt, en_dt)

            await useMakeDtShareofSearch.initialize()

            var res = []

            for (const major of useMakeDtShareofSearch.majorClsList) {
              res.push(major.title)
            }

          case 'searchtag':
            const useMakeDtSearchTag = new makeDtSetSearchTag(this.sel_category, st_dt, en_dt)

            await useMakeDtSearchTag.initialize()

            var res = []

            for (const major of useMakeDtSearchTag.majorClsList) {
              res.push(major.title)
            }
            
          case 'insight':
            const useMakeDtInsight = new makeDtSetInsight(this.sel_category, st_dt, en_dt)

            await useMakeDtInsight.initialize()

            var res = []

            for (const major of useMakeDtInsight.majorClsList) {
              res.push(major.title)
            }

            return res
        }
      },

      async saveToExcel(cat_id, serv_nm, st_dt, en_dt, dataset) {
        switch(serv_nm) {
          case 'marketoverview':
            const expXlMarketOverviewCls = new ExpXlMarketOverview()

            return await expXlMarketOverviewCls.xlExport(cat_id, st_dt, en_dt, dataset)

          case 'shareofsearch':
            const expXlShareofSearch = new ExpXlShareofSearch()

            return await expXlShareofSearch.xlExport(cat_id, st_dt, en_dt, dataset)

          case 'searchtag':
            const expXlSearchTag = new ExpXlSearchTag()

            return await expXlSearchTag.xlExport(cat_id, st_dt, en_dt, dataset)

          case 'insight':
            const expXlInsight = new ExpXlInsight()

            return await expXlInsight.xlExport(cat_id, st_dt, en_dt, dataset)   
        }
      },

      async copyToClipboard(msgId, targetText) {
        try {
          if (targetText.length == 0)
            throw new Error("AI 분석 결과 없음")

          await navigator.clipboard.writeText(targetText)

          this.copiedId = msgId
          setTimeout(() => (this.copiedId = null), 2000)

          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Copy to clipboard successful`,
              icon: "EditIcon",
              variant: "success",
            },
          });
        } catch (err) {
          console.error('클립보드 복사 실패:', err)

          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Copy to clipboard failed`,
              icon: "EditIcon",
              variant: "success",
            },
          });
        }
      }
    },

    setup() {
      console.log('----- setup -----')
      return {}
    },

    async created() {
      console.log('----- created -----')

      this.user_id = String(useJwt.getUserData().adacctId)
      this.sess_id = crypto.randomUUID()
    
      this.messages = []
      this.messages.push(
        { id: 0, role:'bot', type: 'request', text:'질문을 입력하거나 추천 질문 중 하나를 선택해 주세요.', time: this.getCurrTime() } 
      )

      this.followUps = []
      this.questions = []
    },

    mounted() {
      const msgData = JSON.parse(sessionStorage.getItem(jwtDefaultConfig.agentMessageKey) ?? '[]')
      const statData = JSON.parse(sessionStorage.getItem(jwtDefaultConfig.agentStatusKey))

      if (statData) {
        this.isAnswered = statData.answered
        this.isTyping = statData.typing
      }

      if (msgData.length > 0) {
        this.messages = msgData
        this.cnt = msgData.length - 1
      }
    }
}
</script>

<style lang="scss">
@import "@core/scss/base/bootstrap-extended/_variables.scss";

:root {
  --border-radius-lg : 12px;
  --border-radius-md : 8px;
  
  // --color-background-primary: rgba(48, 48, 46, 1);
  // --color-background-secondary: rgba(38, 38, 36, 1);
  // --color-background-info: rgba(37, 62, 95, 1);
  
  // --color-border-primary: rgba(222, 220, 209, 0.4);
  // --color-border-secondary: rgba(222, 220, 209, 0.3);
  // --color-border-tertiary: rgba(222, 220, 209, 0.15);
  
  // --color-text-primary: rgba(250, 249, 245, 1);
  // --color-text-secondary: rgba(194, 192, 182, 1);
  // --color-text-tertiary: rgba(156, 154, 146, 1);
  // --color-text-info: rgba(128, 170, 221, 1);
  // --color-text-success: rgba(122, 185, 72, 1);

  --color-background-primary: rgba(255, 255, 255, 1);
  --color-background-secondary: rgba(245, 244, 237, 1);
  --color-background-info: rgba(214, 228, 246, 1);
  
  --color-border-primary: rgba(31, 30, 29, 0.4);
  --color-border-secondary: rgba(31, 30, 29, 0.3);
  --color-border-tertiary: rgba(31, 30, 29, 0.15);
  
  --color-text-primary: rgba(20, 20, 19, 1);
  --color-text-secondary: rgba(61, 61, 58, 1);
  --color-text-tertiary: rgba(115, 114, 108, 1);
  --color-text-info: rgba(50, 102, 173, 1);
  --color-text-success: rgba(38, 91, 25, 1);
  
  --font-mono: ui-monospace, monospace;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.agent-wrap {
  display: flex;
  flex-direction: column;
  height: calc(100% - 20px);
  border: 3px solid var(--color-border-tertiary); 
  border-radius: var(--border-radius-lg); 
  overflow: hidden;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 5px;
  // padding: 10px;
  background: var(--color-background-primary); 
}
.agent-hdr {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 0.5px solid var(--color-border-tertiary); 
  background: var(--color-background-secondary); 
}
.agent-hdr-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--color-background-info); 
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-info); 
  font-size: 15px;
}
.agent-hdr-title {
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-primary); 
}
.agent-hdr-sub {
  font-size: 11px;
  color: var(--color-text-success); 
  display: flex;
  align-items: center;
  gap: 4px;
}
.agent-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #3a9;
  display: inline-block;
}
.msgs {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.msgs-row {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}
.msgs-row.user {
  flex-direction: row-reverse;
}
.msgs-av {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 500;
  flex-shrink: 0;
}

.msgs-av.user {
  background: var(--color-background-info); 
  color: var(--color-text-info); 
}

.msgs-av.bot {
  background: var(--color-background-secondary); 
  color: var(--color-text-secondary); 
  border: 0.5px solid var(--color-border-tertiary); 
}
.msgs-bub {
  max-width: 100%;
  padding: 8px 5px;
  border-radius: 14px;
  font-size: 12px;
  line-height: 1.6;
  color: var(--color-text-secondary); 
}

.msgs-bub-line {
  margin: 0 0 8px 0;  /* 항목 사이 간격 */
  padding-left: 4px;
  line-height: 1.8;   /* 줄 간격 */
}

.msgs-bub-line:last-child {
  margin-bottom: 0;   /* 마지막 항목 하단 여백 제거 */
}

.msgs-bub.bot {
  width: fit-content;  /* 현재 dot 크기에 맞게 고정 */
  min-width: unset;    /* 기존 min-width 초기화 */
  background: var(--color-background-secondary); 
  border-bottom-left-radius: 3px;
  border: 0.5px solid var(--color-border-tertiary); 
}
.msgs-bub.user {
  background: var(--color-background-info); 
  color: var(--color-text-info); 
  border-bottom-right-radius: 3px;
}
.msgs-bub-time {
  font-size: 10px;
  color: var(--color-text-tertiary); 
  margin-top: 3px;
}

.msgs-typing-wrap {
  display: flex;
  flex-direction: column;  /* 세로 방향 정렬 */
  gap: 6px;                /* dot과 문구 사이 간격 */
}

.msgs-typing-text {
  font-size: 11px;
  color: var(--color-text-info);
  white-space: nowrap;  /* 텍스트 줄바꿈 방지 */
}

.msgs-row.user .msgs-bub-time {
  text-align: right;
}
.msgs-tdot {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--color-text-tertiary); 
  animation: bl 1.2s infinite;
  margin: 0 2px;
}
.msgs-tdot:nth-child(2) {
  animation-delay: 0.2s;
}
.msgs-tdot:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes bl {
  0%,
  80%,
  100% {
    opacity: 0.2;
  }
  40% {
    opacity: 1;
  }
}
.q-panel {
  border-top: 0.5px solid var(--color-border-tertiary); 
  padding: 12px 14px;
  background: var(--color-background-primary); 
}

.user-q-panel {
  border-top: 0.5px solid var(--color-border-tertiary); 
  padding: 12px 14px;
  background: var(--color-background-secondary); 
}

.q-label {
  font-size: 11px;
  color: var(--color-text-tertiary); 
  font-weight: 500;
  letter-spacing: 0.04em;
}
.q-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
}
.q-btn {
  height: auto;
  text-align: left;
  padding: 8px 12px;
  border-radius: var(--border-radius-md); 
  border: 0.5px solid var(--color-border-secondary); 
  background: var(--color-background-primary); 
  color: var(--color-text-primary); 
  font-size: 13px;
  cursor: pointer;
  transition: background 0.12s;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.4;
}
.q-btn:hover {
  background: var(--color-background-info); 
}
.q-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.q-btn i {
  color: var(--color-text-tertiary); 
  flex-shrink: 0;
}

.user-q-input {
  height: auto;
  text-align: left;
  padding: 8px 12px;
  border-radius: var(--border-radius-md); 
  border: 0.5px solid var(--color-border-secondary); 
  background: var(--color-background-primary); 
  color: var(--color-text-primary); 
  font-size: 13px;
  cursor: pointer;
  transition: background 0.12s;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.4;
}
.user-q-input:hover {
  background: var(--color-background-primary); 
}
.user-q-input:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.toggle-btn {
  margin-bottom: 2px;
  font-size: 8px;
  color: var(--color-text-primary); 
  background: var(--color-background-secondary);
  border: 0.5px solid var(--color-border-tertiary); 
  border-radius: var(--border-radius-md); 
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0px 10px;
}

.reset-btn {
  font-size: 12px;
  color: var(--color-text-secondary); 
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;
}
.reset-btn:hover {
  color: var(--color-text-primary); 
}
.tab-bar {
  display: flex;
  border-bottom: 0.5px solid var(--color-border-tertiary); 
  background: var(--color-background-secondary); 
  padding: 0 16px;
}
.tab {
  padding: 8px 12px;
  font-size: 13px;
  color: var(--color-text-secondary); 
  cursor: pointer;
  border-bottom: 2px solid transparent;
  user-select: none;
}
.tab.on {
  color: var(--color-text-primary); 
  border-bottom-color: var(--color-border-primary); 
  font-weight: 500;
}
.code {
  background: var(--color-background-secondary); 
  border: 0.5px solid var(--color-border-tertiary); 
  border-radius: var(--border-radius-md); 
  padding: 12px;
  font-family: var(--font-mono); 
  font-size: 12px;
  color: var(--color-text-secondary); 
  white-space: pre;
  overflow-x: auto;
  line-height: 1.6;
}
.slabel {
  font-size: 11px;
  font-weight: 500;
  color: var(--color-text-tertiary); 
  letter-spacing: 0.06em;
  margin: 14px 0 6px;
}

.copy-container {
  position: relative;  /* 플로팅 버튼의 기준점 */
  display: inline-block;
  width: 100%;
}

.copy-btn {
  position: absolute;
  top: -2px;
  right: 2px;
  z-index: 10;
  // padding: 2px 6px;
  width: 24px;
  height: 24px;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  // margin: 0;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.copy-btn:hover {
  background: rgba(0, 0, 0, 0.85);
}

/* 페이드 트랜지션 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.when-open,
.when-closed {
  display: none;
}
.collapsed > .when-open,
:not(.collapsed) > .when-closed {
  display: none;
}
:not(.collapsed) > .when-open,
.collapsed > .when-closed {
  display: inline-block;
}

.input-group > .user-q-input {
  border-top-right-radius: var(--border-radius-md) !important;
  border-bottom-right-radius: var(--border-radius-md) !important;
}
</style>